import { functions } from "../firebase";

type UploadResult = {
  secretRef: string;
  secretVersion: string;
};

type ValidationResult = {
  ok: boolean;
  error?: string;
  validatedAt: number;
};

const readFileAsBase64 = (file: File): Promise<string> =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      const result = reader.result as string;
      const commaIndex = result.indexOf(",");
      resolve(commaIndex >= 0 ? result.slice(commaIndex + 1) : result);
    };
    reader.onerror = () => reject(reader.error);
    reader.readAsDataURL(file);
  });

export const uploadAppleSecret = async (
  communityId: string,
  file: File
): Promise<UploadResult> => {
  const content = await readFileAsBase64(file);
  const callable = functions.httpsCallable("uploadAppleSecret");
  const result = await callable({
    communityId,
    filename: file.name,
    contentBase64: content,
  });
  return result.data as UploadResult;
};

export const uploadGoogleSecret = async (
  communityId: string,
  file: File
): Promise<UploadResult> => {
  const content = await readFileAsBase64(file);
  const callable = functions.httpsCallable("uploadGoogleSecret");
  const result = await callable({
    communityId,
    filename: file.name,
    contentBase64: content,
  });
  return result.data as UploadResult;
};

export const uploadAppleIapSecret = async (
  communityId: string,
  file: File
): Promise<UploadResult> => {
  const content = await readFileAsBase64(file);
  const callable = functions.httpsCallable("uploadAppleIapSecret");
  const result = await callable({
    communityId,
    filename: file.name,
    contentBase64: content,
  });
  return result.data as UploadResult;
};

export const uploadApnsSecret = async (
  communityId: string,
  file: File
): Promise<UploadResult> => {
  const content = await readFileAsBase64(file);
  const callable = functions.httpsCallable("uploadApnsSecret");
  const result = await callable({
    communityId,
    filename: file.name,
    contentBase64: content,
  });
  return result.data as UploadResult;
};

export const validateApple = async (
  communityId: string
): Promise<ValidationResult> => {
  const callable = functions.httpsCallable("validateAppleCredentials");
  const result = await callable({ communityId });
  return result.data as ValidationResult;
};

export const validateGoogle = async (
  communityId: string
): Promise<ValidationResult> => {
  const callable = functions.httpsCallable("validateGoogleCredentials");
  const result = await callable({ communityId });
  return result.data as ValidationResult;
};
